const GeographicalInfosite = () => {
    return (
        <div className="card mb-4">
            <div className="card-header">
                <h2>Generell statistikk om 1881’s brukere</h2>
            </div>
            <div className="card-body">
                <ul>
                    <li>1881 har ca. 1,6 millioner unike ukentlige brukere fordelt på web og app</li>
                    <li>37% av brukerne har over 650.000 kr i årlig personinntekt</li>
                    <li>52% av brukerne har universitetsutdannelse</li>
                    <li>Mobil er største brukskanal, og står for over 70% av trafikken </li>
                    <li>Kjønnsfordeling er ca. 50/50</li>
                </ul>
                <p className="mt-2 mb-0 text-muted"><small>Kilde: Google Analytics, Kantar Dekningstall, Interne statistikkverktøy. 2025</small> </p>
            </div>
        </div>
    );
}

export default GeographicalInfosite;